import httpClientPrivate from '../../../libs/httpClient/httpClientPrivate'
import api from '@/constant/END_POINT'
import { useMutation } from '@tanstack/react-query'
import message from '@/libs/message'

const fetchDeleteHealthClaimApprover = async (id: string) => {
  const response = await httpClientPrivate.delete(api.backoffice.deleteUserApprovalCondition(id))
  return response.data
}

const useDeleteHealthClaimApprover = () => {
  const mutationKey = ['useDeleteHealthClaimApprove']
  const mutationFn = async (id: string) => await fetchDeleteHealthClaimApprover(id)

  return useMutation({
    mutationFn,
    mutationKey,
    onSuccess: () => message.success('ลบข้อมูลผู้อนุมัติสำเร็จ'),
    onError: () => message.error('ลบข้อมูลผู้อนุมัติไม่สำเร็จ'),
  })
}

export { useDeleteHealthClaimApprover, fetchDeleteHealthClaimApprover }
